
import { useState } from "react";
import Question from "./Question";
import QuestionAction from "./QuestionAction";
import Form from "./form/Form";

export default function QuestionSection({ discussion, onReloadNeeded }) {
	const [isEdit, setIsEdit] = useState(false);

	const handleSuccessEdit = (e) => {
		setIsEdit(false);
		onReloadNeeded();
	}

	return (
		<>
			{discussion.is_owner && (
				<>
					<QuestionAction discussion={discussion} isEdit={isEdit} setIsEdit={setIsEdit} onReloadNeeded={onReloadNeeded} />
					<div className="spacer p-[5px]"></div>
				</>
			)}
			{isEdit ? (
				<Form discussion={discussion} onSuccess={() => handleSuccessEdit()} />
			) : (
				<Question discussion={discussion} />
			)}
		</>
	)
}
